import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_TEL, CTAButton, GuidanceLine } from './shared';
// 09 — MID-PAGE CTA · [Conversion] [Lead Gen]
export function MidPageCTA() {
  return <section className="w-full bg-paper" data-id="element-229">
      <div className="mx-auto w-full max-w-6xl px-5 py-14 sm:px-6 md:py-20 lg:px-8" data-id="element-230">
        <div className="rounded-frame bg-forest px-7 py-14 text-center shadow-card-lg md:px-16 md:py-16" data-id="element-231">
          <div className="mx-auto flex justify-center" data-id="element-232">
            <GuidanceLine data-id="element-233" />
          </div>
          <h2 className="mx-auto mt-5 max-w-2xl font-serif text-[32px] leading-[1.12] tracking-[-0.015em] text-paper md:text-h2" data-id="element-234">
            You Do Not Need Every Answer Before You Call
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-body-lg text-paper/75" data-id="element-235">
            Start with a confidential conversation about what happened and what
            you are worried about.
          </p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-236">
            <CTAButton href="#quick-claim-form" className="px-7" data-id="element-237">
              Request a Confidential Claim Review
            </CTAButton>
            <a href={PHONE_TEL} className="inline-flex min-h-[50px] items-center justify-center gap-2 rounded-btn border border-paper/25 px-6 text-body font-semibold text-paper transition-colors hover:bg-paper/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-238">
              <PhoneIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-239" />
              Call {PHONE_DISPLAY}
            </a>
          </div>
          <p className="mt-5 text-small text-paper/55" data-id="element-240">
            No long questionnaire. No obligation to proceed.
          </p>
        </div>
      </div>
    </section>;
}